import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetCompaniesByUserQuery } from '../../application/features/companies/company-api';
import useCurrentUser from './useCurrentUser';
import { setCurrentCompany } from '../../application/features/common/commonSlice';
var usePersistCompany = function () {
    var dispatch = useDispatch();
    var companyId = useCurrentUser().companyId;
    var _a = useGetCompaniesByUserQuery().data, companies = _a === void 0 ? [] : _a;
    useEffect(function () {
        var handleBeforeUnload = function () {
            localStorage.setItem('current-company', companyId !== null && companyId !== void 0 ? companyId : '');
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function () {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [companyId]);
    useEffect(function () {
        var persistedCompanyId = localStorage.getItem('current-company');
        if (persistedCompanyId) {
            var persistedCompany = companies.find(function (c) { return c.id === persistedCompanyId; });
            if (persistedCompany) {
                localStorage.removeItem('current-company');
                dispatch(setCurrentCompany(persistedCompany));
            }
        }
    }, [companies, dispatch]);
};
export default usePersistCompany;
